export default "__VITE_ASSET__I1YgW445__"